export type FileWithRelativePath = File & {
  webkitRelativePath?: string;
};

/**
 * エクスプローラーで選択されたフォルダ配下のファイルを File[] として取得する
 */
export const extractFilesFromFolderInput = (e: React.ChangeEvent<HTMLInputElement>): File[] | null => {
  const fileList = e.currentTarget.files;
  if (!fileList || fileList.length === 0) return null;
  const files = Array.from(fileList) as FileWithRelativePath[];
  const isFolderSelected = files.some((file) =>
    typeof file.webkitRelativePath === 'string' && file.webkitRelativePath.includes('/'),
  );
  if (!isFolderSelected) return null;
  return files;
};

type ExtractDnDResult =
  | { type: 'not-folder' }
  | { type: 'empty-folder' }
  | { type: 'files'; files: File[] };

/**
 * ドラッグ＆ドロップされたフォルダ配下のファイルを File[] として取得する
 */
export const extractFilesFromDnD = async (e: React.DragEvent<HTMLElement>): Promise<ExtractDnDResult> => {
  const items = e.dataTransfer.items;
  if (!items || items.length === 0) return { type: 'not-folder' };
  const entry = items[0]?.webkitGetAsEntry();
  if (!entry || entry.isFile) return { type: 'not-folder' };
  const files: File[] = [];
  const traverse = async (entry: any): Promise<void> => {
    if (entry.isFile) {
      const file: File = await new Promise((resolve) => entry.file((f: File) => resolve(f)));
      files.push(file);
      return;
    }
    if (entry.isDirectory) {
      const reader = entry.createReader();
      const readEntries = (): Promise<any[]> => new Promise((resolve) => reader.readEntries(resolve));
      for (; ;) {
        const entries = await readEntries();
        if (!entries.length) break;
        for (const child of entries) {
          await traverse(child);
        }
      }
    }
  };
  await traverse(entry);
  if (files.length === 0) return { type: 'empty-folder'};
  return { type: 'files', files };
};
